'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.applicationProp = applicationProp;
exports.notificationUtilsProp = notificationUtilsProp;
exports.domainsProp = domainsProp;
exports.servicesProp = servicesProp;
exports.modelConstructorsProp = modelConstructorsProp;
exports.modelProp = modelProp;
exports.collectionProp = collectionProp;
exports.valueLinkProp = valueLinkProp;
exports.keycloakUserInfoProp = keycloakUserInfoProp;
exports.roleProp = roleProp;
exports.anyEnumProp = anyEnumProp;
exports.enumProp = enumProp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var _contextUtils = require('./contextUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location) {
        var normalizedComponentName = componentName || '<<anonymous>>';
        var propValue = props[propName];
        if (propValue === null || propValue === undefined) {
            if (isRequired) {
                return new Error('Required ' + location + ' \'' + propName + '\' was not specified in ' + normalizedComponentName + '\'.');
            }
            return null;
        }

        return validate(props, propName, normalizedComponentName, location);
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
}

function applicationProp() {
    return _propTypes2.default.object.isRequired;
}

function notificationUtilsProp() {
    return _propTypes2.default.shape({
        showNotification: _propTypes2.default.func.isRequired,
        showNotificationAndRedirect: _propTypes2.default.func.isRequired
    }).isRequired;
}

function domainsProp(domainName) {
    _auroraJavascriptUtils.assert.array(domainName);

    return _propTypes2.default.object.isRequired;
}

/**
 * check `models` prop for present of services
 */
function servicesProp(servicesNames) {
    _auroraJavascriptUtils.assert.array(servicesNames);

    var shape = servicesNames.reduce(function (result, name) {
        return _extends({}, result, _defineProperty({}, (0, _contextUtils.getDomainNameAndServiceName)(name).serviceName, _propTypes2.default.object.isRequired));
    }, {});

    return _propTypes2.default.shape(shape).isRequired;
}

/**
 * check `models` prop for present of models
 */
function modelConstructorsProp(modelNames) {
    _auroraJavascriptUtils.assert.array(modelNames);

    var shape = modelNames.reduce(function (result, name) {
        return _extends({}, result, _defineProperty({}, (0, _contextUtils.getDomainNameAndModelName)(name).modelName, _propTypes2.default.func.isRequired));
    }, {});

    return _propTypes2.default.shape(shape).isRequired;
}

/**
 * prop is instance of model from some domain
 */
function modelProp(modeName) {
    _auroraJavascriptUtils.assert.string(modeName);

    return createChainableTypeChecker(function (props, propName, componentName, location) {
        var propValue = props[propName];

        if (propValue.Attributes) {
            return null;
        }

        return new Error(location + ' \'' + propName + '\' must be model in ' + componentName + '\'.');
    });
}

function collectionProp(domainAndModelName) {
    _auroraJavascriptUtils.assert.string(domainAndModelName);

    var _getDomainNameAndMode = (0, _contextUtils.getDomainNameAndModelName)(domainAndModelName),
        modelName = _getDomainNameAndMode.modelName;

    return createChainableTypeChecker(function (props, propName, componentName, location) {
        var propValue = props[propName];

        if (propValue.model && propValue.model.className) {
            if (propValue.model.className === modelName) {
                return null;
            }
        }

        return new Error(location + ' \'' + propName + '\' must be hateoas collection (type: ' + domainAndModelName + ') in ' + componentName + ', actual value is: ' + JSON.stringify(propValue) + '\'.');
    });
}

function valueLinkProp() {
    return _propTypes2.default.shape({
        value: _propTypes2.default.any,
        requestChange: _propTypes2.default.func.isRequired
    });
}

function keycloakUserInfoProp() {
    return _propTypes2.default.shape({
        email: _propTypes2.default.string,
        family_name: _propTypes2.default.string,
        given_name: _propTypes2.default.string,
        name: _propTypes2.default.string,
        preferred_username: _propTypes2.default.string,
        sub: _propTypes2.default.string,
        user_id: _propTypes2.default.number
    });
}

function roleProp() {
    return _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired
    })]);
}

function anyEnumProp() {
    return _propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired
    });
}

function enumProp(enumClass) {
    _auroraJavascriptUtils.assert.func(enumClass);
    _auroraJavascriptUtils.assert.object(enumClass.enumValues);

    return _propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired
    });
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/propTypeUtils.js
// module id = 716
// module chunks = 118